import { h } from 'preact';
import { Link } from 'preact-router/match';

const Header = () => (
	<nav className="navbar header-bar" role="navigation" aria-label="main navigation">
		<div className="container">
		<div className="navbar-brand">
			<Link className="logo" href="/">
				<img src="assets/logo.png" />
			</Link>
			<Link href="/">
				<h1 className="header-title">Sandy Monster</h1>
			</Link>

			<a role="button" className="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
				<span aria-hidden="true"></span>
				<span aria-hidden="true"></span>
				<span aria-hidden="true"></span>
			</a>
		</div>

		<div id="navbarBasicExample" className="navbar-menu">
			<div className="navbar-end">
				<Link href="/contact" className="navbar-item">
					Contact
				</Link>

				<div className="navbar-item has-dropdown is-hoverable">
					<a className="navbar-link">
						More
					</a>

					<div className="navbar-dropdown">
						<Link href="/about" className="navbar-item">
							About
						</Link>
					</div>
				</div>
			</div>
		</div>
		</div>
	</nav>
);

export default Header;



// WEBPACK FOOTER //
// ./components/header/index.js